import { Api } from 'models/services/api';
import { ReadSatelliteKitchensQuery } from 'models/services/graphql';

import { SatelliteKitchenCollectionData } from '../collection';

type DataToFetch = {
  centralKitchenId: string;
  nextToken?: string;
};

const RequestQuery = `
  query ReadSatelliteKitchens($centralKitchenId: ID!, $nextToken: String) {
    ${ReadSatelliteKitchensQuery}
  }
`;

type ResponseData = {
  data: {
    readSatelliteKitchens: SatelliteKitchenCollectionData;
  }
}

class ReadCollectionGql {

  readonly result?: SatelliteKitchenCollectionData;
  private readonly api: Api<ResponseData>;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToFetch): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const result = api.response.data.readSatelliteKitchens;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, result, api });
  }

}

export { ReadCollectionGql };
